import type {Pinia} from 'pinia';
import {defineNuxtPlugin, tryUseNuxtApp, useRuntimeConfig} from '#app';
import {setBrandIllustrations2026Reader} from '@malt/asset-utils';
import {BRAND_ILLUSTRATIONS_2026_FLAG} from '../brand-illustrations-flag';
import {useFeatureFlagsStore} from '../store/feature-flags.store';

setBrandIllustrations2026Reader(() => {
    const pinia = tryUseNuxtApp()?.$pinia as Pinia | undefined;
    if (!pinia) {
        return false;
    }

    return useFeatureFlagsStore(pinia).featureFlags[BRAND_ILLUSTRATIONS_2026_FLAG] === true;
});

export default defineNuxtPlugin({
    name: 'nuxt-features-module-load-feature-flags-plugin',
    parallel: true,
    dependsOn: ['fetch-auth'],
    setup: async () => {
        const config = useRuntimeConfig();
        const flagsConfig: string[] = config.public['@malt/nuxt-features-module'].flags || [];

        const {init} = useFeatureFlagsStore();

        await init(flagsConfig);
    },
});
